import { createSlice } from "@reduxjs/toolkit";

// Создаем slice (редьюсер + экшены)
const themeSlice = createSlice({
  name: "theme",
  initialState: {
    theme:
      localStorage.getItem("theme") === null
        ? true
        : localStorage.getItem("theme") === "true"
          ? true
          : false,
  },
  reducers: {
    setTheme: (state) => {
      state.theme = !state.theme;
      localStorage.setItem("theme", state.theme);
    },
  },
});

// Экшены
export const { setTheme } = themeSlice.actions;

export default themeSlice.reducer;
